import React from "react";
import RightArrow from "../../images/Svg/ArrowIcon.svg";
import blueArrow from "../../images/Svg/checkProfle/blueArrow.svg";
import { pushGaEvent } from "../../utils/ga_events";

export default function CheckProfileComponents({ data, username }) {
  const handleLink = () => {
    pushGaEvent(data.title + "_BUTTON_CLICKED_FROM_CHECK_PROFILE");
    window.open(data.link + username, "_blank");
  };
  return (
    <div
      className="border-[#E1E1E1] w-[160px] profile_btn_hover rounded-[12px] h-[99px] border p-[16px] hover:bg-[#EEEFFF]"
      target="_blank"
    >
      <div onClick={handleLink} className="cursor-pointer">
        <div className="items-center flex justify-between  cursor-pointer">
          <div className="flex items-center hover:text-[#5463FF]">
            <img src={data.icon} alt="" />
          </div>
          <img className="white_arrow" src={RightArrow} alt="" />
          <img className="blue_arrow hidden" src={blueArrow} alt="" />
        </div>
        <p className="text-[18px] pt-[8px]">{data.title}</p>
      </div>
    </div>
  );
}
